module.exports = __webpack_public_path__ + "img/map-view-ship.342f9763.png";